<template>
  <div>

    <TitlePage :title="$t('features')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="6">
        <v-btn elevation="2" color="secondary" small class="mr-2" :to="pathCreate">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('create') }}
        </v-btn>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('filterResults')" hide-details dense></v-text-field>
      </v-col>

      <v-col cols="12" md="12">
        <ItemActions :selected="selected" @message="actionHandler"></ItemActions>
      </v-col>
    </v-row>

    <div class="mt-5">
      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search">

        <template v-slot:item.icon="{ item }">
          <v-img :src="item.icon" max-width="30"></v-img>
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon @click="edit(item._id)" :title="$t('edit')" color="primary">mdi-file-edit</v-icon>
          <v-icon @click="confirmRemove(item._id)" :title="$t('delete')" color="primary">mdi-delete</v-icon>
        </template>

        <template v-slot:item.status="{ item }">
          <v-switch v-model="item.status" inset @change="updateSingleStatus(item)" dense hide-details class="mt-0"></v-switch>
        </template>

      </v-data-table>
    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";

const exportService = require('@/services/export')

export default {
  name: 'Features',
  components: {ItemActions, ModalDelete, TitlePage},
  data() {
    return {
      pathCreate: '/settings/features/create/',
      pathEdit: '/settings/features/edit/',
      search: '',
      selected: [],
      headers: [
        { text: this.$t('Id'), align: 'start', value: '_id'},
        { text: this.$t('name'), align: 'start', value: 'name'},
        { text: this.$t('icon'), value: 'icon', sortable: false},
        { text: this.$t('status'), value: 'status', sortable: false},
        { text: this.$t('actions'), align: 'start', value: 'action', },
      ],
      items: [],
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: ''
    };
  },
  async created(){
    this.setLoading(true);
    this.items = await this.getItems();
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'features/index',
      'updateItem':'features/update',
      'deleteItem': 'features/delete',
      'massiveDeleteItem': 'features/massDelete'
    }),

    async actionHandler(type) {
      switch (type) {
        case "edit":
          await this.edit(this.selected[0]._id)
          break;
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },

    edit(id){
      this.$router.push(this.pathEdit+id)
    },

    confirmRemove(id){
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove(){
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async removeHandler(mode){
      if(this.typeDelete == 'single'){
        await this.remove(mode)
      }else if(this.typeDelete == 'massive'){
        await this.massiveRemove(mode)
      }else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode){

      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        var result = await this.deleteItem({id:this.ids_to_delete[0]})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          this.items = await this.getItems();
          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode){
      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);


        var result = await this.massiveDeleteItem({_id:{$in:this.ids_to_delete}})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          this.items = await this.getItems();
          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },
    async updateSingleStatus(item){

      await this.setLoading(true);
      var result = await this.updateItem({id:item._id, item: {status: item.status}})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }
    },
    async export(){
      var csv = await exportService.getCsv(this.headers, this.items)
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
  },
  mounted() {

  },
}
</script>
